import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=2edccb47&"
import script from "./Portfolio.vue?vue&type=script&lang=ts&"
export * from "./Portfolio.vue?vue&type=script&lang=ts&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&lang=less&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports